export interface bankStatement {
    id: number;
    name: string;
}
export const slim_2: Array<bankStatement> = [
    {
        id:0,
        name: "Choose...",
    },
    {
        id:1,
        name: "3 Months",
    },
    {
        id:2,
        name: "6 Months",
    },
   
];
